import { marked } from 'marked';
import DOMPurify from 'dompurify';

/** Tiny DOM helpers so views stay readable without a framework. */
export function h<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Record<string, string | boolean | ((e: Event) => void)> = {},
  ...children: Array<Node | string | null | undefined>
): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (typeof v === 'function') el.addEventListener(k.replace(/^on/, '').toLowerCase(), v);
    else if (typeof v === 'boolean') {
      if (v) el.setAttribute(k, '');
    } else el.setAttribute(k, v);
  }
  for (const c of children) if (c !== null && c !== undefined) el.append(c);
  return el;
}

export const text = (s: string) => document.createTextNode(s);

export function markdown(src: string): HTMLElement {
  const el = h('div', { class: 'md' });
  el.innerHTML = DOMPurify.sanitize(marked.parse(src, { async: false, gfm: true }) as string);
  return el;
}

export const when = (ms: number | string) => {
  const d = new Date(ms);
  return `${d.toLocaleDateString()} ${d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
};
export const ago = (ms: number) => {
  const s = Math.round((Date.now() - ms) / 1000);
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.round(s / 60)} min ago`;
  if (s < 86400) return `${Math.round(s / 3600)} h ago`;
  return `${Math.round(s / 86400)} d ago`;
};
export const duration = (a: number, b: number | null) =>
  `${Math.max(1, Math.round(((b ?? Date.now()) - a) / 60000))} min`;

export function diffView(patch: string): HTMLElement {
  const el = h('div', { class: 'diff' });
  for (const line of patch.split('\n')) {
    const cls =
      line.startsWith('+++') || line.startsWith('---')
        ? 'muted'
        : line.startsWith('+')
          ? 'add'
          : line.startsWith('-')
            ? 'del'
            : line.startsWith('@@')
              ? 'hunk'
              : '';
    el.append(h('span', { class: cls }, line + '\n'));
  }
  return el;
}

export const empty = (msg: string) => h('div', { class: 'empty' }, msg);
